import { createStore, select } from '@ngneat/elf';
import {
  getEntity,
  selectAllEntities,
  selectEntity,
  selectMany,
  selectManyByPredicate, setEntities,
  updateAllEntities,
  upsertEntities,
  withEntities
} from '@ngneat/elf-entities';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

import { Dc3Topic, Topic } from './topic';
import { windowDebug } from '../../tools/debug';
import { Tables } from '../database.types';

export const topicStore = createStore(
  {name: 'topics'},
  withEntities<Topic>()
);

// appPersistState(topicStore);

export const topicsObj$ = topicStore.pipe(
  select(store => store.entities)
);

@Injectable({providedIn: 'root'})
export class TopicRepository {
  private _tempTopicsSubject = new BehaviorSubject<number[]>([]);
  tempTopics$ = this._tempTopicsSubject.asObservable();

  addTemp(topicId: number) {
    this._tempTopicsSubject.next([
      ...this._tempTopicsSubject.value,
      topicId
    ])
  }

  removeTemp(topicId: number) {
    this._tempTopicsSubject.next([
      ...this._tempTopicsSubject.value.filter(id => id !== topicId),
    ])
  }


  getTopic(topicId: number) {
    return topicStore.query(getEntity(topicId));
  }

  getTopic$(topicId: number) {
    return topicStore.pipe(selectEntity(topicId));
  }

  getTopics$(topicIds: number[]) {
    return topicStore.pipe(selectMany(topicIds));

  }

  topics$ = topicStore.pipe(selectAllEntities());

  // topicsObj$ = topicStore.pipe(
  //   select(store => store.entities)
  // );

  trackerTopics$ = topicStore.pipe(
    selectManyByPredicate(x => !!x.range_target && !!x.is_active_tracker),
    map(topics => {
      topics.sort((a, b) => {
        const valA = !!a.order_number ? a.order_number : 9999;
        const valB = !!b.order_number ? b.order_number : 9999;
        return valA - valB
      });
      return topics;
    })
  );

  pinnedTopics$ = topicStore.pipe(
    selectManyByPredicate(x => x.is_pinned)
  );

  standardTopics$ = topicStore.pipe(
    selectManyByPredicate(x => !x.range_target || !x.is_active_tracker)
  )

  constructor() {
    windowDebug('TopicRepo', this);
  }

  getTopicsObj() {
    return topicStore.getValue().entities;
  }

  set(topics: Topic[]) {
    topicStore.update(setEntities(topics));
  }

  upsert(topics: Topic[]) {
    topicStore.update(upsertEntities(topics));
  }

  deleteTopics(topics: Topic[]) {
    const deleteTopics =
      topics.map(topic => ({...topic, removed: true}))
    this.upsert(deleteTopics);
  }

  resync() {
    topicStore.update(updateAllEntities(x => ({...x, synced: false})))
  }

  reset() {
    topicStore.reset();
  }


}
